import mobileEnhancerPlugin from './plugins/mobileEnhancerPlugin';
import dataBindingComponentsEnhancerPlugin from './plugins/dataBindingComponentsEnhancerPlugin';

export default [mobileEnhancerPlugin, dataBindingComponentsEnhancerPlugin];
